import { FormikHelpers } from "formik";
import ModelTypeForm from "./ModelTypeForm";
import { useGetModelType } from "./api/getModelType";
import { useEditModelType } from "./api/editModelType";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditModelType = ({handleCloseModal, modelTypeId}: EditModelTypeProps)  => {
  const getModelTypeQuery = useGetModelType({modelTypeId: modelTypeId})
  const editModelTypeMutation = useEditModelType({data: {}, modelTypeId});

  const handleSubmit = async (values: IPostEditModelType, { setSubmitting }: FormikHelpers<IPostEditModelType>): Promise<void> => {
    try {
      await editModelTypeMutation.mutateAsync({
        data: values,
        modelTypeId: modelTypeId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getModelTypeQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getModelTypeQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους Συσκευής</div>
    )
  }

  return (
    <>
      {!getModelTypeQuery.isLoading && getModelTypeQuery.data &&
        <ModelTypeForm initialValues={getModelTypeQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditModelTypeProps {
  modelTypeId: number;
  handleCloseModal: () => void;
}

export default EditModelType;